import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsRepeatRightLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowsRepeatRightLeft"><Path d="M17.25 3L19.75 5.5L17.25 8" stroke="currentColor" strokeLinecap="square"/><Path d="M5.75 21L3.25 18.5L5.75 16" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 18.5H19.5V13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 10.5V5.5H19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowsRepeatRightLeft;
